import { Link } from 'react-router-dom'
import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { TeacherExamList } from '../../../components/teacher-exam-list'
import { CreatedExams } from '../../../components/created-exams'
import { ScoredExams } from '../../../components/scored-exams'
import { FilterBtn } from '../../../styles/results'

const TeacherAssignments = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Link to='/teacher/assignments/create'>
                            <FilterBtn>
                                CREATE ASSIGNMENT
                            </FilterBtn>
                        </Link>

                        <Heading>
                            Assignments
                        </Heading>
                        <Breadcrumb
                            crumbs={['Assignments']}
                        />
                        <TeacherExamList isAssignment />
                        <CreatedExams isAssignment />
                        <ScoredExams isAssignment />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default TeacherAssignments
